import React, { useEffect, useState } from 'react';
import './App.css';
import CollapsibleDateCounter from './components/CollapsibleDateCounter';
import PhotoCarousel from './components/PhotoCarousel';

function App() {
  const startDate = new Date('2018-07-22');
  const [hearts, setHearts] = useState([]);

  const years = Math.floor((new Date() - startDate) / (365.25 * 24 * 60 * 60 * 1000));
  const yearWords = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen'];
  const yearText = yearWords[years] || years;
  
  useEffect(() => {
    const generateHearts = () => {
      const newHearts = [];
      for (let i = 0; i < 15; i++) {
        newHearts.push({
          id: i,
          left: Math.random() * 100,
          animationDelay: Math.random() * 15,
          size: Math.random() * 15 + 10
        });
      }
      setHearts(newHearts);
    };
    
    generateHearts();
  }, []);
  
  
  return (
    <div className="App">
      <img src="/images/hero-background.png" className="hero-background" alt="" />
      
      <div className="floating-hearts">
        {hearts.map(heart => (
          <span
            key={heart.id}
            className="heart"
            style={{
              left: `${heart.left}%`,
              animationDelay: `${heart.animationDelay}s`,
              fontSize: `${heart.size}px`
            }}
          >
            💕
          </span>
        ))}
      </div>
      
      <div className="floating-clouds">
        <img src="/images/floating-clouds.png" className="cloud" alt="" />
        <img src="/images/floating-clouds.png" className="cloud" alt="" />
        <img src="/images/floating-clouds.png" className="cloud" alt="" />
      </div>
      
      <img src="/images/stars-sparkles.png" className="sparkles" alt="" />
      <img src="/images/love-birds.png" className="love-birds" alt="" />
      <img src="/images/couple-silhouette.png" className="couple-silhouette" alt="" />
      
      <div className="top-counter">
        <CollapsibleDateCounter startDate={startDate} />
      </div>
      
      <div className="hero-section">
        <h1>YYZ & XXZ</h1>
        <p>{yearText} years of shared dreams, endless laughter, and infinite love</p>
        <PhotoCarousel />
      </div>
    </div>
  );
}

export default App;